import { render, staticRenderFns } from "./addTask.vue?vue&type=template&id=269cb821&scoped=true&"
import script from "./addTask.vue?vue&type=script&lang=js&"
export * from "./addTask.vue?vue&type=script&lang=js&"
import style0 from "./addTask.vue?vue&type=style&index=0&id=269cb821&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269cb821",
  null
  
)

export default component.exports